<template>
  <div id="wrapper" :style="{ height: window.height - 244 + 'px' }">
    <div v-if="this.$store.state.curDoc">
      <b-alert id="alert" show>{{ this.$store.state.curDoc.name }}</b-alert>
      <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
      <pdf v-for="i in numPages"
           :key="i"
           :page="i"
           :src="src"
           style="width: 100%; padding: 5px 0;"
      ></pdf>
    </div>
    <div v-else>
      <b-alert variant="danger" show>Missing document</b-alert>
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser';
import crypto from 'crypto-js';
import pdf from 'vue-pdf';
import okm from '../api';

export default {
    name: 'ShowDocument',
    components: {
      pdf
    },
    data() {
      return {
        error: null,
        src: undefined,
        numPages: undefined,
        window: {
          width: 0,
          height: 0
        }
      }
    },
    methods: {
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      showDocument() {
        if (this.$store.state.curDoc) {
          let docUuid = this.$store.state.curDoc.uuid;

          okm.getDownloadToken(docUuid).then(res => {
            console.log("getDownloadToken", res.data);
            let downloadUrl = this.$store.state.url + "/download?PTK=" + res.data;
            console.log("downloadUrl", downloadUrl);
            this.src = pdf.createLoadingTask(downloadUrl);
            this.src.promise.then(pdf => {
              this.numPages = pdf.numPages;
            });
          }).catch(err => {
            this.showError(err);
          });
        } else {
          this.showError("Missing document");
        }
      },
      readLicense() {
        const licenseProperty = 'doc-signer.license';
        okm.getConfiguration(licenseProperty).then(res => {
          if (res.data && res.data.value) {
            const licEnc = res.data.value;
            console.log("License:", licEnc);

            okm.getClusterId().then(res => {
              console.log("clusterId:", res.data);
              let decrypted = crypto.AES.decrypt(licEnc, res.data);
              let decString = decrypted.toString(crypto.enc.Utf8);
              let licJson = JSON.parse(decString);

              this.$store.commit('setLocationEnable', licJson.locationEnabled);
              this.$store.commit('setCameraEnabled', licJson.cameraEnabled);
            }).catch(err => {
              this.showError(err);
            });
          } else {
            console.log("Missing license info");
          }
        }).catch(err => {
          this.showError(err);
        });
      },
      getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            };
            this.$store.commit('setLocation', location);
          });
        } else {
          this.showError("GeoLocation not supported");
        }
      },
      showError(err) {
        Sentry.captureException(err);
        this.error = err;
      }
    },
    mounted() {
      this.error = null;
      this.showDocument();
      this.readLicense();

      if (this.$store.state.locationEnabled) {
        this.getLocation();
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    }
  }
</script>

<style scoped>
  #alert {
    margin-bottom: 0;
  }
  #wrapper {
    overflow: auto;
    height: 500px;
  }
</style>
